import styled from 'styled-components';

export const Wrapper = styled.div`
  display: inline-block;
  width: 100%;
`;

export const Textarea = styled.textarea`
  /* Custom styles not covered by global classes (.t-font-m, .m-input-field) */
  padding-right: 1rem; /* Override global's 0 right padding */
  background-color: var(--t-brand-bg-color);
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &::placeholder {
    color: var(--t-brand-alt-color);
  }

  &:hover {
    border-color: var(--t-brand-fg-color);
  }

  &:focus {
    border-color: var(--t-interactive-accent-color);
    box-shadow: 0 0 0 2px rgba(var(--t-brand-bg-color-rgb), 0.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: var(--t-brand-alt-color);
  }
`;
